import './style.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.node,
  ]).isRequired,
  type: PropTypes.string,
  justIcon: PropTypes.bool,
  variant: PropTypes.oneOf(['filled', 'outlined']),
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

const defaultProps = {
  type: 'submit',
  variant: 'filled',
  buttonType: 'primary',
  disabled: false,
  justIcon: false,
};

class Button extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      children,
      onClick,
      justIcon,
      variant,
      disabled,
      buttonType,
      className,
      type,
    } = this.props;
    // 判斷second情形
    if (buttonType === 'secondary') {
      return (
        <button
          className={classNames({
            button: true,
            'filled--second': variant === 'filled',
            'outlined--second': variant === 'outlined',
            buttonText: !justIcon,
            icon: justIcon,
            [className]: className,
          })}
          type={type}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </button>
      );
    }

    return (
      <button
        className={classNames({
          button: true,
          filled: variant === 'filled',
          outlined: variant === 'outlined',
          buttonText: !justIcon,
          icon: justIcon,
          [className]: className,
        })}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Button/index.js
 **/